import { useCallback, useState } from "react";
import SidebarDrawer from "../components/_default/SidebarDrawer";
import { Box, Button } from "@mui/material";



const useSidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
 console.log("okay");
  const openSidebar = useCallback(() => {
    setIsSidebarOpen(true);
  }, []);

  const closeSidebar = useCallback(() => {
    setIsSidebarOpen(false);
  }, []);

  return { isSidebarOpen, openSidebar, closeSidebar };
};
const Test = () => {
  const { isSidebarOpen, openSidebar, closeSidebar } = useSidebar();
  return (
    <div>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={(e) => {
            e.stopPropagation();
            openSidebar();
          }}
          sx={{ width: "300px" }}
        >
          {isSidebarOpen ? "Close Sidebar" : "Open Sidebar"}
        </Button>
      </Box>

      <SidebarDrawer
        isSidebarOpen={isSidebarOpen}
        closeSidebar={closeSidebar}
        HeaderComponent={<Box>majid</Box>}
        FooterComponent={() => <div>Footer</div>}
        ContentComponent={() => <div>content</div>}
      >
        majid
      </SidebarDrawer>
    </div>
  );
};
export default Test;
